import React, {useContext} from 'react';
import { Icon, List } from 'semantic-ui-react';
import AmountProvider from '../../Provider/AmountProvider';
import GlobalContext from '../../../contexts/GlobalContext';
import Utility from '../../../Utility';

/**
 * 
 * @param {supplValue} props 
 */
function BookingSupplementList(props) {
  const [globalContext] = useContext(GlobalContext) as any;

  const getSupplementInfos = (supplement) => {
    let name = ''
    let image = ''

    if (supplement?.extraId) {
      name = props.extras[supplement.extraId]?.name ?? ''
      image = props.extras[supplement.extraId]?.photos[0] ?? ''
    }

    if (supplement?.optionId) {
      name = props.options[supplement.optionId]?.name ?? ''
      image = props.options[supplement.optionId]?.photos[0] ?? ''
    }

    return { name, image }
  }

  const { name } = getSupplementInfos(props.supplValue)

  return (
    <List.Item as="a">
      <Icon name="triangle right" />
      <List.Content>
        <List.Header>
          <div className="d-flex justify-content-between">
            <div>
              {Utility.ucFirst(name)} x {props.supplValue.totalQuantity}
            </div>
            <div>
              {props.supplValue.isInclude
                ? <h4><div style={{ display: 'inline' }}>{globalContext.translations.includedValue}</div></h4>
                : <h4><AmountProvider amount={props.supplValue.totalAmount} currency={props.supplValue.currency} /></h4>
              }
            </div>
          </div>
        </List.Header>
      </List.Content>
    </List.Item>
  )
}

export default BookingSupplementList;